var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      attrs: {
        title: "Compliance & Monitoring",
        customClass: "p-6 relative vld-parent"
      }
    },
    [
      _c("loading", {
        attrs: { active: _vm.loading, "is-full-page": false },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex flex-col md:flex-row justify-between w-full gap-4"
        },
        [
          _c("div", { staticClass: "bg-gray-100 rounded-lg p-4 flex-1" }, [
            _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
              _vm._v("\n        Monitored Assets*\n        "),
              _c(
                "span",
                {
                  staticClass: "text-xs font-bold ml-2 py-1 px-2 rounded-full",
                  class: {
                    "bg-red-100 text-red-700": _vm.criticalCount > 0,
                    "bg-gray-300 text-gray-700": _vm.criticalCount === 0
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.criticalCount !== null
                          ? _vm.criticalCount + " critical"
                          : "N/A"
                      ) +
                      "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-sm text-gray-700" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.displayOrNA(_vm.monitored)) +
                  " monitored ·\n        " +
                  _vm._s(_vm.displayOrNA(_vm.unmonitored)) +
                  " unmonitored ·\n        " +
                  _vm._s(_vm.displayOrNA(_vm.excluded)) +
                  " excluded\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mt-2 h-3 bg-gray-300 rounded-full overflow-hidden"
              },
              _vm._l(_vm.serviceMetrics, function(service, namespace) {
                return _c("div", {
                  key: namespace,
                  staticClass: "h-full inline-block",
                  class: _vm.namespaceColor(namespace),
                  style: {
                    width: (service.count / _vm.totalAssets) * 100 + "%"
                  }
                })
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex justify-between text-xs text-gray-600 mt-1"
              },
              [
                _c("span", [
                  _vm._v(
                    "Total: " +
                      _vm._s(_vm.displayOrNA(_vm.totalAssets)) +
                      " assets"
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.coverage !== null ? _vm.coverage.toFixed(1) : "N/A"
                    ) + "% coverage"
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bg-gray-100 rounded-lg p-4 flex-1" }, [
            _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
              _vm._v("\n        Cost Analysis\n        "),
              _c(
                "span",
                {
                  staticClass: "text-xs font-bold ml-2",
                  class: {
                    "text-green-600": _vm.changePercentage < 0,
                    "text-red-600": _vm.changePercentage > 0
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.changePercentage !== null
                          ? _vm.formatPercentage(_vm.changePercentage)
                          : "N/A"
                      ) +
                      "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-sm text-gray-700" }, [
              _c("p", [
                _c("strong", [_vm._v("Current Month:")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "float-right font-semibold text-black" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.formatCurrency(_vm.currentMonthCost)) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-1" }, [
                _c("strong", [_vm._v("Previous Month:")]),
                _vm._v(" "),
                _c("span", { staticClass: "float-right text-gray-800" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formatCurrency(_vm.previousMonthCost)) +
                      "\n          "
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-6" },
        _vm._l(_vm.serviceMetrics, function(service, namespace) {
          return _c("div", { key: namespace, staticClass: "border-t pt-4" }, [
            _c("details", { staticClass: "mb-2 group" }, [
              _c(
                "summary",
                {
                  staticClass: "font-semibold cursor-pointer flex items-center"
                },
                [
                  _c("span", { staticClass: "mr-2" }, [
                    _vm._v(
                      _vm._s(namespace.replace("AWS/", "")) +
                        " (" +
                        _vm._s(service.count) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass:
                        "w-4 h-4 ml-auto group-open:rotate-90 transition-transform",
                      attrs: {
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M9 5l7 7-7 7",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", { staticClass: "text-sm text-gray-600 mt-2" }, [
                _c(
                  "li",
                  [
                    _c("strong", [_vm._v("Monitoring Ratings:")]),
                    _vm._v(" "),
                    _vm._l(service.ratings, function(count, rating) {
                      return _c("span", { key: rating, staticClass: "mr-2" }, [
                        _vm._v("\n              " + _vm._s(rating) + ": "),
                        _c("span", { class: _vm.ratingColor(rating) }, [
                          _vm._v(_vm._s(count))
                        ])
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("li", [
                  _c("strong", [_vm._v("Alarm Coverage:")]),
                  _vm._v(
                    "\n            " +
                      _vm._s(service.activeAlarms) +
                      " / " +
                      _vm._s(service.recommendedAlarms) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _vm.costs[namespace]
                  ? _c("li", [
                      _c("strong", [_vm._v("Cost:")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatCurrency(_vm.costs[namespace])) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass:
            "inline-flex items-center px-5 py-3 mt-4 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200",
          attrs: { to: "/" + _vm.id + "/monitoring" }
        },
        [
          _vm._v("\n    View Detailed Compliance\n    "),
          _c(
            "svg",
            {
              staticClass: "ml-2 h-4 w-4",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }
            },
            [_c("path", { attrs: { d: "M5 12h14M12 5l7 7-7 7" } })]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c3f2c83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c3f2c83","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/InfoCards/MonitoredCard.vue
// module id = null
// module chunks = 